export default {
  loading: 'Läser in...',
  categories: {
    basic: 'Grundläggande',
    object: 'Objekt',
    symbol: 'Symboler',
    arrow: 'Pilar',
    flowchart: 'Flödesschema',
    animal: 'Djur',
    game: 'Kort & schack',
    dialog_balloon: 'Dialogballonger',
    electronics: 'Elektronik',
    math: 'Matematisk',
    music: 'Musik',
    misc: 'Diverse',
    raphael_1: 'raphaeljs.com uppsättning 1',
    raphael_2: 'raphaeljs.com uppsättning 2'
  },
  buttons: [
    {
      title: 'Formbibliotek'
    }
  ]
}
